'use strict';
var toPositiveInteger = require('../internals/to-positive-integer');

var $RangeError = RangeError;

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw new $RangeError('Wrong offset');
  return offset;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/to-offset.js
// module id = 349
// module chunks = 0